import {getNonProdStageLabel} from '@hconnect/common/appStages'
import {Icon, LabelSmallMedium} from '@hm/fundamental'
import {mdiAlert} from '@mdi/js'
import {useTranslation} from 'react-i18next'

// Persistent notice shown on every non-production stage (qa/uat/uatr), hidden on prod
export const EnvironmentBanner: React.FC = () => {
  const {t} = useTranslation()
  const stageLabel = getNonProdStageLabel()

  if (!stageLabel) {
    return null
  }

  return (
    <div
      data-test-id="environment-banner"
      data-cy="environment_banner"
      className="w-full h-32px flex items-center justify-start gap-2 px-4 bg-warning text-foreground_inverted overflow-hidden whitespace-nowrap"
    >
      <Icon path={mdiAlert} size="regular" className="text-foreground_inverted shrink-0" />
      <LabelSmallMedium className="text-foreground_inverted overflow-hidden text-ellipsis">
        {t('suite.environmentBanner.message')}
      </LabelSmallMedium>
    </div>
  )
}
